
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 187 180","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M101.56 11.66H91.23a2.41 2.41 0 00-2.41 2.41v2.45a2.41 2.41 0 002.41 2.41h10.33a2.41 2.41 0 002.41-2.41v-2.45a2.41 2.41 0 00-2.41-2.41z","fill":"#00577B"}}),_c('path',{attrs:{"d":"M102.39 6.2H90.4a1.58 1.58 0 00-1.58 1.58v4.11c0 .873.707 1.58 1.58 1.58h11.99a1.58 1.58 0 001.58-1.58V7.78a1.58 1.58 0 00-1.58-1.58z","fill":"#000"}}),_c('path',{attrs:{"d":"M75.8 17.72S61.55-10 97.6 7","stroke":"#000","stroke-width":"1.21","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M52.8 17.11h86.57a5.79 5.79 0 015.79 5.79V147a32.5 32.5 0 01-32.5 32.5H79.51a32.488 32.488 0 01-30.035-20.06A32.503 32.503 0 0147 147V22.91a5.79 5.79 0 015.8-5.8z","fill":"#333"}}),_c('path',{attrs:{"d":"M55.5 20.75h82.4a4.252 4.252 0 014.24 4.25v119a30.094 30.094 0 01-30.09 30H81.34a30.092 30.092 0 01-30.09-30V25a4.25 4.25 0 014.25-4.25z","fill":"#00567C"}}),_c('path',{attrs:{"d":"M57.92 27.41h78.16v78.16H57.92V27.41z","fill":"#B3B3B3","stroke":"#000","stroke-width":"5.45","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M120.63 155.26a5.15 5.15 0 100-10.3 5.15 5.15 0 000 10.3z","fill":"#FCEE21"}}),_c('path',{attrs:{"d":"M54.89 111.64H66.4v11.51H54.89v-11.51zm25.45 0h11.51v11.51H80.34v-11.51zm23.63 0h11.51v11.51h-11.51v-11.51zm21.81 0h11.51v11.51h-11.51v-11.51z","fill":"#1A1A1A"}})])
          )
        }
      }
    